<template lang="pug">
.staff-list
  GenericCard.productList(size='85')
    .sticky-top.bg-white
      .d-flex.flex-column.px-4.py-4
        .text-title รายชื่อพนักงานทั้งหมด
        CustomSearchBox.w-50.mt-2(
          v-model='filterSearch'
          type='text' placeholder='ค้นหาด้วยชื่อ'
          width='100%'
          :isLoading='isLoading'
        )
      hr.m-0

    LoadedContentWrapper(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      //- loadingErrorMessage='เกิดปัญหาในการโหลดข้อมูล'
      .py-2.px-3.scrollable.h-scrollable
        CustomTable(
          :columns='tableColumns'
          :data='filteredTableData'
          :showIndexes='true'
          :showNotificationDots='false'
          @itemClicked='selectItem'
        )

      .sticky-bottom.bg-white
        hr.m-0
        .px-4.py-3
          CustomPagination(
            v-model='currentPage'
            :total='totalPage'
          )

  modal(
    name='user-url'
    width='600' height='350'
    transition='modal-transition'
  )
    //- @closeButtonClicked='hideModal'
    .d-flex.flex-column.h-100.px-4.py-4.my-2
      .my-2.mb-5
        .text-title.text-center.mb-3 link สำหรับใช้ในการ log in สำหรับเซลล์
        .text-center.mb-3 {{selectedItem.name}}
        .text-center
          InputWithIconSlot.my-auto.flex-fill(
            v-if="loginUrl !== ''"
            placeholder='loginUrl'
            :value='loginUrl'
            width='100%'
            disabled
            ref='loginUrlBox'
          )
            i.fa.fa-link
          template(v-else)
            button.btn.btn-upa-secondary.ml-3(@click='generateToken')
              | สร้าง link ใหม่
            br
            .mt-2.text-danger
              | หลังจากสร้างใหม่แล้ว
              br
              | เซลล์จำเป็นต้องเข้าสู่ระบบใหม่ด้วย link ที่ถูกสร้างใหม่เท่านั้น
      .d-flex.mb-3.mx-auto
        button.btn.btn-secondary(@click='hideUrlModal')
          | ปิด
        button.btn.btn-primary.ml-3(v-if="loginUrl !== ''" @click='copyToClipboard(loginUrl)')
          | คัดลอก

</template>

<script>
/* eslint-disable arrow-body-style */
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';
import SellRecordDetail from '@/components/history/dialogs/SellRecord/SellRecordDetail.vue';

export default {
  props: {
    shouldRefresh: { default: false },
  },
  watch: {
    async shouldRefresh() {
      if (this.shouldRefresh === true) {
        await this.loadData();
        this.shouldRefresh = false;
      }
    },

    // reload data
    filterDate: {
      deep: true,
      handler() { this.currentPage = 1; this.loadData(); },
    },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      // return this.tableData.filter((item) => {
      //   return (
      //     // (this.filterDate === '') || (this.$dateUtils.isInRange(item.date, this.filterDate)
      //     // || (!this.filterStatus || item.status.toString() === this.filterStatus)
      //     (
      //       !KEYWORD
      //       || (
      //         KEYWORD && (
      //           item.username.toUpperCase().includes(KEYWORD)
      //           || item.name.toUpperCase().includes(KEYWORD)
      //         )
      //       )
      //     )
      //   );
      // });
      return this.tableData;
    },
  },
  data() {
    const vue = this;
    return {
      isLoading: false,

      // statusList: {
      //   0: 'รออนุมัติ',
      //   1: 'อนุมัติ',
      //   2: 'ไม่อนุมัติ',
      // },
      // filterStatus: '',

      filterDate: '',
      filterSearch: '',
      tableData: [],
      tableColumns: {
        username: {
          title: 'ชื่อผู้ใช้',
          align: 'left',
        },
        name: {
          title: 'ชื่อ - นามสกุล',
          align: 'left',
          computed(row) {
            if (row.firstName && row.lastName) {
              return `${row.firstName} ${row.lastName}`;
            }
            if (row.name) {
              return row.name;
            }
            return '-';
          },
        },
        permissionLevel: {
          title: 'ประเภทผู้ใช้งาน',
          align: 'center',
          type: this.$api.admin.permissions.COL_TYPE.PermissionLevels,
        },
        active: {
          title: 'สถานะ',
          align: 'center',
          type: 'Controls.SWITCH',
          async onClick(row) {
            // console.log(row);
            // vue.showUrlModal(row);

            // eslint-disable-next-line no-param-reassign
            row.active = !row.active;
            try {
              await vue.$api.admin.permissions.updateUser(row.id, {
                // toggle active status
                active: row.active === true ? 1 : 0,
              });
            } catch (e) {
              // eslint-disable-next-line no-param-reassign
              row.active = !row.active;
              alert(`ไม่สามารถเปลี่ยนสถานะผู้ใช้ได้.. \n${e.message}`);
            }
          },
          // onClick(row) {
          //   console.log(row.enabled);
          // },
        },
        loginUrl: {
          title: '',
          align: 'center',
          type: 'Controls.BUTTON', // button
          computed: (row) => {
            if (row.roles.filter(elm => elm.name === 'sales').length === 0) return ''; // disable btn when is not sale
            return `
              <div class='d-flex'>
                <i class="fa fa-external-link-alt" style="font-size: 17px; margin-top: 1px;"></i>
                <div class='ml-2'>link</div>
              </div>
            `;
          },
          onClick(row) {
            if (row.roles.filter(elm => elm.name === 'sales').length === 0) return false; // disable btn when is not sale
            // console.log(row);
            vue.showUrlModal(row);
            return true;
          },
        },
      },

      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItem: {},

      loginUrl: '',
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // reset data
      this.tableData = null;

      // load data
      try {
        const res = await this.$api.admin.permissions.staffsList(
          this.currentPage,
          this.filterSearch,
        );
        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
          this.$emit('finishLoading');
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    selectItem(e) {
      this.selectedItem = e.data;
      console.log(this.selectedItem);
      this.$emit('staffSelected', e.data);
    },
    showUrlModal(data) {
      this.selectedItem = data;
      this.$modal.show('user-url');
      // this.fetchLoginUrl();
    },
    hideUrlModal() {
      // console.log('close');
      this.$modal.hide('user-url');
    },

    async fetchLoginUrl() {
      try {
        const res = await this.$api.admin.permissions.getToken(this.selectedItem.id);
        this.loginUrl = `${res.data.token}`;
      } catch (e) {
        alert(`ไม่สามารถโหลด login url ได้ \n${e}`);
      }
    },
    async generateToken() {
      try {
        const res = await this.$api.admin.permissions.generateToken(this.selectedItem.id);
        this.loginUrl = `${window.location.origin}/#/login?token=${res.data.token}`;
        // this.fetchLoginUrl();
      } catch (e) {
        alert(`ไม่สามารถสร้าง token ได้ \n${e}`);
      }
    },
    copyToClipboard(text) {
      // console.log(text);
      // const input = this.$refs.loginUrlBox.$el.children[0];
      // input.focus();
      // this.$copyText(this.loginUrl, input);
      // console.log(input);

      // // TODO: actually copy to the clipboard
      // document.execCommand('copy');
      console.log(this.$copyText);
      this.$copyText(text).then(
        (e) => {
          alert('คัดลอก url สำเร็จ');
          console.log(e);
          this.hideUrlModal();
        },
        (e) => {
          alert('ไม่สามารถคัดลอก url ได้');
          console.log(e);

          // just focus the text field and let the user copy themselve
          const input = this.$refs.loginUrlBox.$el.children[0];
          input.focus();
        },
      );
    },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    this.loadData();
  },
  components: {
    CustomerCompactDetailHeader,
    SellRecordDetail,
  },
};
</script>

<style lang="scss">
// .staff-list {}
</style>
